import {useEffect} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import css from './layout.module.css';
import {Sidebar} from './Sidebar';
import {CreateProvider} from '../../context/CreateProvider';
import {useAuth} from '../../context/AuthProvider';
import {Spinner} from '../common/ui';
import {LoginPage} from '../../pages/LoginPage';
import owlIcon from '../../assets/owl.png';

function Splash() {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
      }}
    >
      <img src={owlIcon} alt="Owlly" style={{width: 72, borderRadius: 18}} />
      <Spinner large />
    </div>
  );
}

export function AppShell() {
  const {ready, uid, user} = useAuth();
  const navigate = useNavigate();

  // "/" jumps to the notes list and focuses search.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      const typing =
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable;
      if (typing || e.metaKey || e.ctrlKey || e.altKey) {
        return;
      }
      if (e.key === '/') {
        e.preventDefault();
        navigate('/notes');
        setTimeout(() => {
          document.getElementById('notes-search')?.focus();
        }, 60);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);

  if (!ready) {
    return <Splash />;
  }
  // No guest accounts on web — sign in with Google/Apple first.
  if (!uid || user?.isAnonymous) {
    return <LoginPage />;
  }

  return (
    <CreateProvider>
      <div className={css.shell}>
        <Sidebar />
        <main className={css.main}>
          <Outlet />
        </main>
      </div>
    </CreateProvider>
  );
}
